<template>
  <div>
    <ModalAlert
      :id="modalId"
      :variant="'warning'"
      :title="$t('engine.aiGenerate.closeConfirm.title', languageEngine)"
      :confirm="$t('engine.aiGenerate.closeConfirm.confirm', languageEngine)"
      :cancel="$t('engine.aiGenerate.closeConfirm.cancel', languageEngine)"
      :confirmVariant="'primary'"
      :showCancel="true"
      :showClose="true"
      :noCloseOnEsc="true"
      :noCloseOnBackdrop="true"
      @onConfirm="onConfirm"
      @onCancel="onCancel"
      @onClose="onCancel"
    >
      <template #description>
        <div class="fs-sa-16">{{ $t('engine.aiGenerate.closeConfirm.message', languageEngine) }}</div>
      </template>
    </ModalAlert>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ModalAlert from "@components_system/Shared/Tools/ModalAlert/ModalAlert";

export default {
  name: "ModalAICloseConfirm",
  components: {
    ModalAlert,
  },
  data() {
    return {
      modalId: "modal-ai-close-confirm",
    };
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      modalActive: "design/modals/modalActive",
    }),
  },
  methods: {
    openModal() {
      this.$bvModal.show(this.modalId);
    },
    onConfirm() {
      this.$store.dispatch("design/modals/callback", {
        key: this.modalId,
        clear: true,
        func: "confirmed",
        data: {},
      });
      this.$bvModal.hide(this.modalId);
    },
    onCancel() {
      this.$store.dispatch("design/modals/callback", {
        key: this.modalId,
        clear: true,
        func: "cancelled",
        data: {},
      });
      this.$bvModal.hide(this.modalId);
    },
  },
  watch: {
    modalActive: {
      handler(next) {
        if (next == this.modalId) {
          this.openModal();
        }
      },
    },
  },
};
</script>
